import { IS_VALID_MARKER } from './constants.mjs';

export default function markAsAsyncIsInvalid({ target }) {
  target.dataset[IS_VALID_MARKER] = false;
}
